import module from 'finanzas/module.js'
import template from './template.html'

function FinancesPosicionbancariaPrestamosAgregarComponent ($filter, $http, $q, CatalogoEmpresas, CatalogoEmpresasCuentas, FinancesPosicionbancariaPrestamos) {
  var $ctrl = this,
    orderBy = $filter('orderBy')

  $ctrl.$onInit = $onInit
  $ctrl.aceptar = aceptar
  $ctrl.cerrar = cerrar
  $ctrl.seleccionarCuenta = seleccionarCuenta
  $ctrl.seleccionarEmpresa = seleccionarEmpresa
  $ctrl.procesando = false
  $ctrl.destinatario = {
    empresa: null,
    cuenta: null,
  }

  function $onInit () {
    $ctrl.promise = $q.all([
      CatalogoEmpresas.get({empresas_internas: true})
        .then(function (response) {
          $ctrl.empresas = orderBy(response.data, 'descripcion')
        }),

      $http.get('api/empresa/cuenta/moneda', {
          params: {id_empresa: $ctrl.idEmpresa, id_cuenta: $ctrl.idCuenta},
          schema: {id: 'number'},
        })
        .then(function (response) {
          $ctrl.data = {
            capital: null,
            destinatario_id_empresa: undefined,
            destinatario_id_cuenta: undefined,
            destinatario_id_moneda: undefined,
            fecha: new Date(),
            financiamiento: [],
            id_moneda: response.data.id,
            id_naturaleza: 'C',
            importe: null,
            interes: null,
            interes_porcentaje: 0,
            tipo_cambio: undefined,
            notas: '',
          }
        }),
    ])
  }

  function aceptar () {
    if ($ctrl.procesando)
      return

    $ctrl.procesando = true

    FinancesPosicionbancariaPrestamos.post($ctrl.idEmpresa, $ctrl.idCuenta, $ctrl.data)
      .then(function (response) {
        $ctrl.onClose({$event: {data: response.data}})
      })
      .finally(function () {
        $ctrl.procesando = false
      })
  }

  function cerrar (data) {
    if ($ctrl.procesando)
      return

    $ctrl.onClose({$event: {data: data}})
  }

  function seleccionarEmpresa () {
    $ctrl.cuentas = null
    $ctrl.data.destinatario_id_moneda = undefined
    $ctrl.data.destinatario_id_empresa = $ctrl.destinatario.empresa.id
    $ctrl.data.destinatario_id_cuenta = undefined
    $ctrl.destinatario.cuenta = null

    CatalogoEmpresasCuentas.get({id_empresa: $ctrl.destinatario.empresa.kardex_id_empleado})
      .then(function (response) {
        $ctrl.cuentas = orderBy(response.data, 'descripcion')
      })
  }

  function seleccionarCuenta () {
    $ctrl.data.destinatario_id_moneda = $ctrl.destinatario.cuenta.id_moneda
    $ctrl.data.destinatario_id_cuenta = $ctrl.destinatario.cuenta.id_cuenta

    if ($ctrl.data.id_moneda === $ctrl.data.destinatario_id_moneda) {
      $ctrl.data.tipo_cambio = 1
      $ctrl.data.destinatario_importe = $ctrl.data.importe
    } else {
      $ctrl.data.destinatario_importe = $ctrl.data.id_moneda === 1
        ? ($ctrl.data.importe / $ctrl.data.tipo_cambio)
        : ($ctrl.data.importe * $ctrl.data.tipo_cambio)
    }
  }
}

module.component('financesPosicionbancariaPrestamosAgregar', {
  controller: FinancesPosicionbancariaPrestamosAgregarComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idCuenta: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/posicionbancaria/prestamos/agregar/component.js